export default "__VITE_ASSET__f0002dc1__"